import {
    post_request
  } from './axiosFun'
  
  //查询菜单列表
  export const get_menu_list = (params) => {
    params = {
      row: {}
    }
    return post_request("/web/directory/get_directory", params)
  }


// WEBPACK FOOTER //
// ./src/api/menu.js